<template>
  <div style="height: 100%">
    <transition name="slidedealer" mode="in-out">
      <v-slide-x-transition leave-absolute hide-on-leave>
        <div class="transition">
          <component v-if="!loading" :is="view">
            <template v-slot:header="props">
              <div class="header">
                <div class="primary center" style="height: 60px">
                  <v-img
                    width="100px"
                    max-width="100px"
                    src="@/assets/logo.png"
                  ></v-img>
                </div>
                <div class="py-3 subheader">
                  <div class="text-right pr-3" @click="changeLanguage">
                    <v-btn
                      small
                      :color="flag == 'th' ? 'white' : 'primary'"
                      :style="
                        `background-color: ${
                          flag == 'th' ? '#330066' : 'white'
                        }; font-weight: bold`
                      "
                      icon
                      >TH</v-btn
                    >
                    <v-btn
                      small
                      :color="flag == 'en' ? 'white' : 'primary'"
                      :style="
                        `background-color: ${
                          flag == 'en' ? '#330066' : 'white'
                        }; font-weight: bold`
                      "
                      icon
                      >EN</v-btn
                    >
                  </div>
                  <div v-if="props.title" class="text-center">
                    <span
                      class="primary--text pb-2 PSLKanda4Pro"
                      style="font-weight: bold; font-size: 20px;"
                      >{{ props.title }}</span
                    >
                  </div>
                </div>
              </div>
            </template>
          </component>
          <div v-else class="text-center">
            <div class="text-center">
              <v-progress-circular
                indeterminate
                style="margin-top: 150px;"
                color="primary"
                size="48"
              ></v-progress-circular>
              <div class="text-center pt-5" v-if="changeLanguageMessage">
                {{ changeLanguageMessage }}
              </div>
            </div>
          </div>
        </div>
      </v-slide-x-transition>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import queryString from "query-string";
import PrivacyNotice from "./PrivacyNotice.vue";
import Register from "./Register.vue";
import Profile from "./Profile.vue";
import FlightInfo from "./FlightInfo.vue";
import i18n from "@/plugins/i18n";

export default {
  components: {
    PrivacyNotice,
    Register,
    Profile,
    FlightInfo,
  },
  data() {
    return {
      loading: true,
      changeLanguageMessage: "",
    };
  },
  mounted() {
    var vm = this;
    vm.queryinit();

    if (vm.query.action && vm.query.action == "saveUserId" && this.query.lang) {
      if (this.query.lang == "en") {
        vm.changeLanguageMessage = "Language change is in progress";
      } else {
        vm.changeLanguageMessage = "กำลังดำเนินการเปลี่ยนภาษา";
      }
    }

    vm.init();
  },
  methods: {
    init() {
      var vm = this;
      return new Promise(async (resolve) => {
        var liffid = process.env.VUE_APP_LIFF_ID;

        if (vm.query.apptype == "line") {
          await vm.initializeLiff(liffid);
          vm.$store.state.userid = vm.query.userid
            ? vm.query.userid
            : vm.$store.state.profile.userId + "__" + vm.query.pageid;
          resolve();
        } else {
          vm.$store.state.userid = vm.query.userid;
          window.extAsyncInit = function() {
            // the Messenger Extensions JS SDK is done loading
          };
          resolve();
        }

        if (
          vm.query.action &&
          vm.query.action == "saveUserId" &&
          vm.query.apptype == "line"
        ) {
          await vm.saveOldUserId();
          vm.$liff.closeWindow();
        } else {
          vm.setLanguage();
          if (vm.query.view !== "FlightInfo") {
            await vm.$store.dispatch("getMemberByUserId");
          }
          vm.loading = false;
        }
      });
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
          // vm.loading = false;
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        console.error(error);
      }
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
    changeLanguage() {
      if (i18n.locale == "en") {
        i18n.locale = "th";
        this.$store.state.locale = "th";
      } else {
        i18n.locale = "en";
        this.$store.state.locale = "en";
      }
    },
    setLanguage() {
      let lang = this.query.lang;
      if (lang) {
        i18n.locale = lang;
        this.$store.state.locale = lang;
      }
    },
    async saveOldUserId() {
      let vm = this;
      let isSendMsg = false;
      let data = {
        userid: vm.$store.state.userid,
        pageid: vm.query.pageid,
        code_id: vm.$store.state.profile.userId + "__" + vm.query.pageid,
      };

      await axios
        .post(`${vm.serverUrl}saveOldUserId`, data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            vm.loading = false;

            let lang = this.query.lang;
            if (lang && lang == "en") {
              await vm.$store.dispatch("sendMessage", "English");
            } else {
              await vm.$store.dispatch("sendMessage", "ภาษาไทย");
            }
          }
        });
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    flag() {
      return i18n.locale;
    },
  },
};
</script>

<style lang="scss">
.header {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
}
.subheader {
  background: #ffffff;
}
.btn-purple {
  background: radial-gradient(
    129.77% 129.77% at 48.82% -19.51%,
    #aa86dd 0%,
    rgba(106, 67, 162, 0.97) 32.18%,
    rgba(82, 47, 131, 0.92) 60.19%,
    #3d1a6e 95.35%
  );
  box-shadow: 16px 8px 18px rgba(33, 73, 198, 0.26),
    inset 14px 12px 13px -4px rgba(255, 255, 255, 0.23);
}
.btn-gray {
  background: radial-gradient(
    129.77% 129.77% at 48.82% -19.51%,
    #aeaeae 0%,
    #959595 32.18%,
    #8b8b8b 60.19%,
    #838383 71.88%,
    #817f7f 95.35%
  );
  box-shadow: 16px 8px 18px #d6d6d6,
    inset 14px 12px 13px -4px rgba(255, 255, 255, 0.23);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.vue-tel-input-vuetify {
  border-radius: 28px;
  height: 52px;
  .v-input.v-text-field--rounded {
    &:nth-child(2) {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }
  }
  .country-code {
    width: 130px !important;
    .v-text-field--rounded {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  }
  .v-text-field .v-select__selections .vti__flag {
    position: relative;
  }
}

.swal2-styled:focus {
  box-shadow: none !important;
}
.swal-custom-content {
  font-size: 16px !important;
  padding-bottom: 16px !important;
}
.swal-custom-btn-gray-outline {
  border-radius: 28px !important;
  border: 2px solid #838383 !important;
  outline-offset: 4px !important;
  background: #fff !important;
  color: #838383 !important;
  height: 48px !important;
  font-size: 16px !important;
}
.swal-custom-btn-purple {
  background: radial-gradient(
    129.77% 129.77% at 48.82% -19.51%,
    #aa86dd 0%,
    rgba(106, 67, 162, 0.97) 32.18%,
    rgba(82, 47, 131, 0.92) 60.19%,
    #3d1a6e 95.35%
  ) !important;
  box-shadow: 16px 8px 18px rgba(33, 73, 198, 0.26),
    inset 14px 12px 13px -4px rgba(255, 255, 255, 0.23) !important;
  border-radius: 28px !important;
  height: 48px !important;
  font-size: 16px !important;
}
.swal-custom-action {
  padding: 0 !important;
}
.v-btn {
  letter-spacing: 0;
}
</style>
